import { Bar, CartesianGrid, ComposedChart, Legend, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { BRAND_THEME } from "@/lib/constants";
import { Card } from "@/components/common";

const axis = { tick: { fontSize: 12, fill: "#64748B" }, axisLine: false, tickLine: false };
const day = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-IN", { day: "numeric", month: "short" });

export const TrendCard = ({ data, compare, brand }) => (
  <Card title="Negative feedback by day" subtitle={compare ? "Bars: this period · dashed line: same day number in the previous period" : "Bars: negative feedback · line: average rating"} testid="trend-card">
    <ResponsiveContainer width="100%" height={280}>
      <ComposedChart data={data.map((d) => ({ ...d, label: day(d.date) }))} margin={{ left: 0, right: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" vertical={false} />
        <XAxis dataKey="label" {...axis} minTickGap={16} />
        <YAxis yAxisId="n" {...axis} allowDecimals={false} width={36} />
        {!compare && <YAxis yAxisId="r" orientation="right" domain={[1, 5]} {...axis} width={30} />}
        <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #E2E8F0" }} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar yAxisId="n" dataKey="negative" name="Negative" fill={BRAND_THEME[brand].primary} radius={[6, 6, 0, 0]} maxBarSize={28} />
        {compare
          ? <Line yAxisId="n" dataKey="prev_negative" name="Previous period" stroke="#94A3B8" strokeDasharray="5 4" dot={false} strokeWidth={2} />
          : <Line yAxisId="r" dataKey="avg_rating" name="Avg rating" stroke="#0F172A" dot={false} strokeWidth={2} connectNulls />}
      </ComposedChart>
    </ResponsiveContainer>
  </Card>
);
